import { render, staticRenderFns } from "./ApprovalRead.vue?vue&type=template&id=0932ca3c&scoped=true"
import script from "./ApprovalRead.vue?vue&type=script&lang=js"
export * from "./ApprovalRead.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRead.vue?vue&type=style&index=0&id=0932ca3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0932ca3c",
  null
  
)

export default component.exports